import { ContactUsModel } from './models';
import { createMutation } from '../../libs/react-query';
import getConfig from 'next/config';

const url = 'contact-us';
const { publicRuntimeConfig } = getConfig();

export const useCreateContactUs = createMutation<unknown, Partial<ContactUsModel>>({
  method: 'post',
  url: url,
  headers: {
    'X-App-Version': publicRuntimeConfig?.version,
  },
});
